<header class="header">
  <a routerLink="/" class="logo">
		<span class="fa fa-angle-left"></span>
	</a>

  <a routerLink="/" class="logo float-right">
		<span class="fa fa-times"></span>
	</a>
</header>
